import { render } from "./BaseSwitch.vue?vue&type=template&id=3bc34908"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"

import "./BaseSwitch.vue?vue&type=style&index=0&id=3bc34908&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__